var _circle, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 135,
    viewBox: "0 0 136 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.1117,
    cy: 67.5004,
    r: 52.4013,
    fill: "#F41C1C",
    stroke: "#F41C1C",
    strokeWidth: 1.77632
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4027_26735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2385 51.4467L67.0015 70.8734L63.7646 51.4467C63.687 50.977 63.7125 50.496 63.8394 50.0371C63.9664 49.5782 64.1916 49.1524 64.4996 48.7894C64.8076 48.4263 65.1909 48.1346 65.623 47.9345C66.055 47.7345 66.5254 47.6309 67.0015 47.6309C67.4776 47.6309 67.9481 47.7345 68.3801 47.9345C68.8121 48.1346 69.1955 48.4263 69.5035 48.7894C69.8114 49.1524 70.0367 49.5782 70.1636 50.0371C70.2906 50.496 70.3161 50.977 70.2385 51.4467Z",
    stroke: "white",
    strokeWidth: 7.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0023 87.6647C68.429 87.6647 69.5856 86.5081 69.5856 85.0814C69.5856 83.6546 68.429 82.498 67.0023 82.498C65.5755 82.498 64.4189 83.6546 64.4189 85.0814C64.4189 86.5081 65.5755 87.6647 67.0023 87.6647Z",
    stroke: "white",
    strokeWidth: 5.16667
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.836 67.5C132.836 103.308 103.808 132.336 68 132.336C32.1923 132.336 3.16447 103.308 3.16447 67.5C3.16447 31.6923 32.1923 2.66447 68 2.66447C103.808 2.66447 132.836 31.6923 132.836 67.5Z",
    stroke: "#F41C1C",
    strokeWidth: 5.32895
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4027_26735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.1711,
    height: 62.1711,
    fill: "white",
    transform: "translate(36.0273 35.5273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectSvg);
export default __webpack_public_path__ + "static/media/rejectSvg.2a25e8b8ee4ad56340655a20d0e1f830.svg";
export { ForwardRef as ReactComponent };